import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { EnvConfig } from './Config';

enum BrowserCacheLocation {
  LocalStorage = 'localStorage',
  SessionStorage = 'sessionStorage',
  MemoryStorage = 'memoryStorage',
}
interface AuthConfiguration {
  auth: {
    clientId: string;
    authority?: string;
    redirectUri?: string;
    postLogoutRedirectUri?: string;
    navigateToLoginRequestUrl?: boolean;
  };
  cache?: {
    cacheLocation: BrowserCacheLocation;
    secureCookies: boolean;
  };
  scopes: string[];
  system?: {
    loggerOptions?: any;
  };
}

export const msalConfig: AuthConfiguration = {
  auth: {
    clientId: EnvConfig.clientId, // This is the ONLY mandatory field that you need to supply.
    authority: EnvConfig.authorityUri, // Optional
    redirectUri: EnvConfig.redirectUri, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    secureCookies: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);

            return;
          case LogLevel.Info:
            // no logs required except warning and error
            // console.info(message);

            return;
          case LogLevel.Verbose:
            // no logs required except warning and error
            // console.debug(message);

            return;
          case LogLevel.Warning:
            console.warn(message);

            return;
        }
      },
      piiLoggingEnabled: false,
    },
  },
  scopes: EnvConfig.tokenScopes || [],
};

export const authenticationClientProvider = new PublicClientApplication(msalConfig);
